// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chart-container[data-v-670b2069]{position:relative;height:45vh;width:100%}@media screen and (orientation:landscape){.chart-container[data-v-670b2069]{height:80vh}}@media screen and (min-width:769px)and (max-width:1023px){.chart-container[data-v-670b2069]{height:80vh}}@media screen and (min-width:1024px){.chart-container[data-v-670b2069]{height:656px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
